import { render, staticRenderFns } from "./CartTip.vue?vue&type=template&id=284bc51d"
import script from "./CartTip.vue?vue&type=script&lang=js"
export * from "./CartTip.vue?vue&type=script&lang=js"
import style0 from "./CartTip.vue?vue&type=style&index=0&id=284bc51d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports